import {DmsRequest} from '../common/dms-request';
import {FunctionalHeader} from '../common/functional-header';
import {TechnicalHeaderInRequest} from '../common/technical-header-in-request';
import {UserInformation} from '../common/user-information';
import {GetVehicleRequestBody} from './get-vehicle-request-body';

export class GetVehicleRequest implements DmsRequest {
  readonly simpleName = 'get-vehicle';
  technicalHeader: TechnicalHeaderInRequest;
  functionalHeader: FunctionalHeader;
  userInformation: UserInformation;
  body: GetVehicleRequestBody;
}
